import clsx from "clsx";
import styles from "./letterContainer.module.scss";

export default function LetterContainer(props) {
  const {
    tile,
    ref,
    keyboardChain,
    navigationMode
  } = props;

  const isInKeyboardChain = keyboardChain.find((it) => it.id === tile.id);

  return (
    <div
      className={clsx(
        styles.letterContainer,
        isInKeyboardChain && styles.activeKeyboard,
        navigationMode && styles.keyboardMode
      )}
      ref={(elem) => (ref.current[tile.id] = elem)}
      tabIndex={0}
    >
    </div>
  );
}
